import ProductList from "./ProductList";
export * from "./ProductList";
export default ProductList;